import React from 'react'
import { Grid, styled } from '@mui/material'
import theme from '../../config/styles/theme'

export const GridWrapper = styled(({ borderTop, margin, padding, ...props }) => <Grid {...props} />)`
  border-top: ${props => (props.borderTop ? `2px solid ${theme.palette.brand.gray2}` : null)};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`
export const ChartBubble = styled('div')`
  align-items: center;
  background-color: ${props => props.color};
  border-radius: 100%;
  color: ${props => props.theme.palette.brand.white};
  display: flex;
  font-size: 12px;
  font-weight: 700;
  height: calc((${props => props.value}px * 155) / 100);
  justify-content: center;
  margin: 16px auto 8px;
  max-width: 175px;
  min-width: 60px;
  min-height: 60px;
  max-height: 175px;
  position: relative;
  top: 50%;
  transform: translateY(-50%) scale(1);
  transform-origin: center center;
  transition: transform 0.3s ease;
  width: calc((${props => props.value}px * 155) / 100);

  &.changed {
    transform: translateY(-50%) scale(0);
  }
`
